import { render } from "./S99193.vue?vue&type=template&id=2c2344e6"
const script = {}
script.render = render

export default script